import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  lastFetched: null,
  loading: false,
  error: null,
};

const productGridSlice = createSlice({
  name: 'productGrid',
  initialState,
  reducers: {
    setProducts(state, action) {
      state.products = action.payload;
      state.lastFetched = Date.now();
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearProducts(state) {
      state.products = [];
      state.lastFetched = null;
      state.error = null;
    },
  },
});

export const { setProducts, setLoading, setError, clearProducts } = productGridSlice.actions;
export default productGridSlice.reducer;
